module.exports = __webpack_public_path__ + "img/private-letter.704385b1.png";